import { Component, OnInit, ComponentFactoryResolver, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { FormBuildService } from '../../service/form-build.service';
import { FormHostDirective } from '../../directive/form-host.directive';

@Component({
  selector: 'app-form-build',
  template: '<p> app form build </p>'
})
export class FormBuildComponent implements OnInit {

  @Input()
  key: string;
  @Input()
  parent: FormGroup;

  form: FormGroup;

  @ViewChild(FormHostDirective)
  formHost: FormHostDirective;

  @Output()
  onComplete: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onCancel: EventEmitter<any> = new EventEmitter<any>();

  constructor(public formBuildService: FormBuildService) { }

  ngOnInit() {
    this.form = new FormGroup({});
    this.formBuildService.build(this.key, true, this.formHost.viewContainerRef, this.form);
  }

  complete() {
    this.onComplete.emit(this.form.value);
    this.clear();
  }

  cancel() {
    this.onCancel.emit();
    this.clear();
  }

  clear() {
    this.form.reset();
  }

}



// WEBPACK FOOTER //
// ./src/app/form/core/component/form-build/form-build.component.ts